<template>
  <div class="border rounded shadow bg-white h-100">
    <LmComponentLoading v-if="isLoading" />
    <div class="d-flex justify-content-between align-items-center px-4 py-3 border-bottom">
      <i class="mdi" :class="icon" style="font-size: 1.5rem"></i>
      <h4 class="text-center m-0">{{ title }}</h4>
      <span class="clickable" @click="$emit('close')">
        <i class="mdi mdi-close" style="font-size: 1.5rem"></i>
      </span>
    </div>
    <div class="scroll">
      <div class="p-4">
        <h6>Trámites a Asociar</h6>
        <b-list-group v-if="linkList.length" class="mb-4">
          <b-list-group-item
            v-for="(item, index) in linkList"
            :key="index"
          >
            <div class="d-flex justify-content-between align-items-center">
              {{ item.processName }}
              <i
                @click="onRemoveProcess(index)"
                class="mdi mdi-delete clickable"
                style="font-size:20px"
              ></i>
            </div>
          </b-list-group-item>
        </b-list-group>
        <template v-else>
          <p class="font-italic text-muted">No hay trámites asociados.</p>
          <hr class="w-100">
        </template>
        <LmButton
          value="Buscar trámites"
          buttonClass="btn-primary"
          @click="$bvModal.show('process-listbuilder-process')"
        />
        <div class="mt-4">
          <LmTreeSelect
            label="Tipo de Asociación"
            :pathToGetOptions="pathToGetLinkTypesOptions"
            v-model="linkType"
          />
          <LmButton
            value="Asociar"
            buttonClass="btn-primary"
            @click="onConfirmLink"
            :disabled="disableLinkButton"
          />
        </div>
      </div>
    </div>

    <b-modal
      id="process-listbuilder-process"
      size="xl"
      title="Trámites"
      @ok="onLinkProcesses"
      @hidden="onCloseProcessListbuilder"
    >
      <div class="process-listbuilder" v-if="isLoading">
        <LmComponentLoading />
      </div>
      <LmListV2
        v-if="listbuilderProps && !isLoading"
        isGraphql
        v-bind="listbuilderProps"
        selectable
        hideActions
        @onRowSelected="onRowSelected"
      />
    </b-modal>
  </div>
</template>

<script>
// Components
import LmListV2 from '@/components/LmListV2'
import LmButton from '@/components/form/elements/LmButton'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'
// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts'
import processesToLinkList from '../utils/processesToLinkList.json'

export default {
  mixins: [lmToasts],
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    linkedProcesses: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      isLoading: false,
      tempLinkList: [],
      linkList: [],
      linkType: null
    }
  },
  components: {
    LmButton,
    LmTreeSelect,
    LmListV2
  },
  computed: {
    pathToGetLinkTypesOptions () {
      return `/processes/relationshiptypes`
    },
    disableLinkButton () {
      if (!this.linkList.length || !this.linkType || this.isLoading) {
        return true
      }
      return false
    },
    gqlVariables () {
      const variables = processesToLinkList.gqlVariables
      const excludeProcesses = this.linkList.concat(this.linkedProcesses).map(el => el?.id || el?.meta?.id).join(' ')
      let q = `NOT (id: ${this.$route.params.id})`
      if (excludeProcesses) {
        q = `NOT (id: ${excludeProcesses} ${this.$route.params.id})`
      }
      variables.q = q
      return variables
    },
    listbuilderProps () {
      const props = processesToLinkList
      props.gqlVariables = this.gqlVariables
      return props
    }
  },
  methods: {
    onRowSelected (event) {
      this.tempLinkList = event
    },
    onLinkProcesses () {
      this.linkList = this.linkList.concat(this.tempLinkList)
    },
    onRemoveProcess (index) {
      this.linkList.splice(index, 1)
    },
    onCloseProcessListbuilder () {
      this.tempLinkList = []
      // Limpio la url del query de busqueda que deja listbuilder
      if (Object.keys(this.$route.query).length) {
        this.$router.replace({ query: null })
      }
    },
    async onConfirmLink () {
      try {
        this.isLoading = true
        await commonsApi.axiosPostWrapper('/processes/newrelationship', {
          id: this.$route.params.id,
          relatedProcesses: this.linkList,
          relationShipType: this.linkType
        })
        this.lmToastSuccessMessage(`Se asociaron ${this.linkList.length} correctamente.`, 'Acción realizada con éxito.')
        this.$emit('onAddLinkedProcesses')
        this.linkList = []
        this.linkType = null
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .process-listbuilder
    height: 80vh
  .scroll
    height: calc(100% - 70px)
    overflow-y: auto
    &:hover
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
    &::-webkit-scrollbar
      width: 8px
    &::-webkit-scrollbar-thumb
      border-radius: 20px
      background: transparent
    &::-webkit-scrollbar-thumb:hover
      background: #555
</style>
